const DateFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/dateFilter/dateFilter.tpl.html',
    controller: 'dateFilterController',
    bindings: {
        criterionTemplate: '<',
        submission: '<',
        advancedFilterType: '<',
        translationsKey: '<?',
        timezoneMode: '<'
    }
};

angular.module('umCore')
    .component('uiDateFilter', DateFilterComponent);
